<template>
  <div class="container_data">
    <div v-if="dataFilter.idForm">
      <el-row type="flex" :gutter="6">
        <el-col :span="3" v-if="activeName === 'kids'">
          <el-select
              v-model="dataFilter.idGrade"
              placeholder="Chọn khối" style="width: 100%"
              @change="handleFilterData"
              :clearable="true"
          >
            <el-option
                v-for="(item, index) in gradeOfSchoolList"
                :key="index"
                :label="item.gradeName"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="3" v-if="activeName === 'kids'">
          <el-select
              v-model="dataFilter.idClass"
              placeholder="Chọn lớp" style="width: 100%"
              @change="handleFilterData"
              :clearable="true"
              :disabled="!dataFilter.idGrade"
          >
            <el-option
                v-for="(item, index) in classList"
                :key="index"
                :label="item.className"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="4" v-if="activeName === 'teacher'">
          <el-select
              v-model="dataFilter.idDepartment"
              placeholder="Chọn phòng ban" style="width: 100%"
              @change="handleFilterData"
              :clearable="true"
          >
            <el-option
                v-for="(item, index) in departmentList"
                :key="index"
                :label="item.departmentName"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="6">
          <el-input
              :clearable="true"
              style="width: 100%"
              placeholder="Nhập tên hoặc số điện thoại"
              v-model="dataFilter.nameOrPhone"
              @keyup.enter.native="handleFilterData"
              @clear="handleFilterData"
          >
            <template #append>
              <el-button
                  icon="el-icon-search"
                  @click="handleFilterData"
              ></el-button>
            </template>
          </el-input>
        </el-col>

        <el-col :span="3">
          <el-select
              v-model="dataFilter.statusAnswer"
              placeholder="Trạng thái" style="width: 100%"
              @change="handleFilterData"
              :clearable="true"
          >
            <el-option
                v-for="(item, index) in optionsStatus"
                :key="index"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>

      <div class="wrap_data">
        <el-tabs tab-position="top" type="card" v-model="activeName" @tab-click="handleClickTab" style="margin-top: 10px">
          <el-tab-pane name="kids">
            <span slot="label">Học sinh</span>
            <KidApplicableManagement
                :data-table="dataKidsApplicable"
                :is-loading="isLoading"
                :id-form="dataFilter.idForm"
                :type-apply="activeName"
                @resetData="handleFilterData"
                ref="kidApplicableManagement"
            />
          </el-tab-pane>
          <el-tab-pane name="teacher">
            <span slot="label">Nhân sự</span>
            <TeacherApplicableManagement
                :data-table="dataTeacherApplicable"
                :is-loading="isLoading"
                :id-form="dataFilter.idForm"
                :type-apply="activeName"
                @resetData="handleFilterData"
                ref="teacherApplicableManagement"
            />
          </el-tab-pane>
        </el-tabs>
      </div>

      <!--  Tác vụ  -->
      <div class="footer_task">
        <el-row type="flex">
          <el-col :span="16">
            <div class="container_nav_page">
              <el-pagination
                  style=" margin-right: 200px"
                  background
                  layout="prev, pager, next, sizes"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentPageChange"
                  :page-sizes="listSizePage"
                  :current-page.sync="pagination.page"
                  :total="pagination.total">
              </el-pagination>
            </div>
          </el-col>

<!--          <el-col :span="8">-->
<!--            <el-row type="flex" :justify="'end'">-->
<!--              <el-col :span="5">-->
<!--                <el-menu-->
<!--                    class="menu_task_form"-->
<!--                    background-color="#67C23A"-->
<!--                    text-color="#FFF-->
<!--"-->
<!--                    active-text-color="#FFF"-->
<!--                    mode="horizontal"-->
<!--                    :unique-opened="true"-->
<!--                    menu-trigger="hover"-->
<!--                >-->
<!--                  <el-submenu index="1" popper-class="sub_menu">-->
<!--                    <template #title>-->
<!--                      Tác vụ-->
<!--                    </template>-->
<!--                    <el-menu-item index="2" @click="handleRemoveMultipleForm" class="submenu-left">-->
<!--                      <template #title>Xoá phiếu khảo sát</template>-->
<!--                    </el-menu-item>-->
<!--                  </el-submenu>-->
<!--                </el-menu>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </el-col>-->
        </el-row>
      </div>
    </div>

    <div v-else
         style="display: flex; align-items: center; justify-content: center; color: #409EFF; height: 100%; gap: 0 10px; font-size: 20px">
      <i class="el-icon-info"/>
      Vui lòng chọn phiếu khảo sát
    </div>

  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import KidApplicableManagement from "@/views/survey_form/component/child_component/KidApplicableManagement.vue";
import TeacherApplicableManagement from "@/views/survey_form/component/child_component/TeacherApplicableManagement.vue";
import SurveyForm from "@/services/SurveyForm";

export default {
  components: {
    TeacherApplicableManagement,
    KidApplicableManagement
  },
  props: {
    dataFormFilter: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      dataKidsApplicable: [],
      dataTeacherApplicable: [],
      dataFilter: {
        idForm: "",
        nameForm: "",
        idGrade: "",
        idClass: "",
        nameOrPhone: "",
        idDepartment: "",
        statusAnswer: null,
      },

      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      optionsStatus: [
        {
          value: 1,
          label: "Đã trả lời"
        },
        {
          value: 0,
          label: "Chưa trả lời"
        }
      ],

      activeName: "kids",
      isLoading: false,
      listSizePage: [10, 30, 40, 50, 100, 200, 500],
    }
  },

  created() {
    this.$store.dispatch('gradeModule/fetchDataGradeOfSchoolList');
  },

  computed: {
    ...mapState('classStore', ['classListCommon']),
    ...mapState('gradeModule', ['gradeOfSchoolList']),
    ...mapGetters('departmentStore', ['departmentList']),

    classList() {
      return this.classListCommon.filter((x) => x.idGrade === this.dataFilter.idGrade);
    },
  },

  watch: {
    dataFormFilter(newVal) {
      if (newVal) {
        this.dataFilter.idForm = newVal.idForm;
        this.dataFilter.nameForm = newVal.nameForm;

        this.fetchDataFilterApplicable();

      } else {
        this.resetFilter();
      }
    }
  },

  methods: {
    handleFilterData() {
      this.pagination.page = 1;
      this.fetchDataFilterApplicable();
    },

    initialData(value) {
      this.dataFilter = value;
      this.fetchDataFilterApplicable();
    },

    fetchDataFilterApplicable() {
      const formData = new FormData();
      const filter = this.dataFilter;
      const pagination = this.pagination;

      this.isLoading = true;

      formData.append("idForm", filter.idForm);
      formData.append("idOrNameForm", filter.nameForm);
      formData.append("TypeUserApplyForm", this.activeName);
      formData.append("pageNumber", pagination.page);
      formData.append("maxPageItem", pagination.limit);

      if (filter.idClass) {
        formData.append("idClass", filter.idClass);
      }

      if (filter.idGrade) {
        formData.append("idGrade", filter.idGrade);
      }

      if (filter.idDepartment) {
        formData.append("idDepartment", filter.idDepartment);
      }

      if (filter.nameOrPhone) {
        formData.append("nameOrPhone", filter.nameOrPhone);
      }

      if (filter.statusAnswer) {
        formData.append("statusAnswer", filter.statusAnswer);
      }

      SurveyForm.getDataFilterApplicable(formData)
          .then((res) => {
            const data = res.data.data;

            if (this.activeName === 'kids') {
              this.dataKidsApplicable = data.listResponse;
            } else if (this.activeName === 'teacher') {
              this.dataTeacherApplicable = data.listResponse;
            }

            this.pagination.total = data.totalRecords;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isLoading = false;
          })
    },

    resetFilter() {
      const filter = this.dataFilter

      filter.idForm = "";
      filter.nameForm = "";
      this.activeName = "kids";

      this.resetDataFilterKid();
      this.resetDataFilterTeacher();
      this.resetPagination();
    },

    resetDataFilterKid() {
      const filter = this.dataFilter;

      filter.idGrade = "";
      filter.idClass = "";
      filter.nameOrPhone = "";

      this.dataKidsApplicable = [];
    },

    resetDataFilterTeacher() {
      const filter = this.dataFilter;

      filter.idDepartment = "";
      filter.nameOrPhone = "";

      this.dataKidsApplicable = [];
    },

    resetPagination() {
      this.pagination = {
        page: 1,
        limit: 10,
        total: 0,
      }
    },

    handleClickTab(value) {
      switch (value.name) {
        case "kids":
          this.resetDataFilterTeacher();
          break;
        case "teacher":
          this.resetDataFilterKid();
          break;
      }

      this.resetPagination();
      this.handleFilterData();
    },

    handleSizeChange(value) {
      this.pagination.limit = value;

      this.fetchDataFilterApplicable();
    },

    handleCurrentPageChange(value) {
      this.pagination.page = value;

      this.fetchDataFilterApplicable();
    }
  }
}
</script>

<style lang="scss" scoped>

.container_data {
  border: 1px solid #78a5e7;
  min-height: 500px;
  padding: 20px 34px;
}

.footer_task {
  margin-top: 20px;
}

.container_nav_page {
  /deep/ .el-pagination {
    display: flex;
    justify-content: end;
  }
}


.menu_task_form {
  background-color: transparent !important;
  display: flex;
  justify-content: end;
  align-content: center;
}
</style>